import ChatBot from '../components/ChatBot'

export default function MCQTest() {
  return (
    <>
      {/* Header */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card rounded-4 border-0" style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #2563eb 100%)' }}>
            <div className="card-body p-4 d-flex align-items-center justify-content-between">
              <div>
                <h4 className="text-white mb-1">
                  <i className="bi bi-clipboard2-pulse-fill me-2"></i>MCQ Medical Assessment
                </h4>
                <p className="text-white opacity-75 mb-0 small">
                  Interactive AI-guided clinical assessment with multiple-choice questions
                </p>
              </div>
              <i className="bi bi-clipboard2-check-fill text-white opacity-25 d-none d-md-block" style={{ fontSize: '4rem' }}></i>
            </div>
          </div>
        </div>
      </div>

      {/* Chat Area */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card rounded-4 shadow-sm" style={{ height: 'calc(100vh - 340px)', minHeight: 400 }}>
            <div className="card-body p-0 d-flex flex-column h-100">
              <ChatBot />
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="alert alert-warning rounded-4 d-flex align-items-start gap-3 mb-0">
            <i className="bi bi-exclamation-triangle-fill fs-5 mt-1 flex-shrink-0"></i>
            <div>
              <strong>Medical Disclaimer</strong>
              <p className="mb-0 small mt-1">
                This AI assessment provides general medical information only. It is not a substitute
                for professional medical advice, diagnosis, or treatment. Always consult a qualified health
                provider. In emergencies, call your local emergency services immediately.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Cards */}
      <div className="row g-3">
        <div className="col-12 col-md-4">
          <div className="card rounded-4 border-0 h-100" style={{ background: '#f5f3ff' }}>
            <div className="card-body d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-center rounded-circle text-white flex-shrink-0"
                style={{ width: 44, height: 44, background: '#7c3aed' }}>
                <i className="bi bi-list-check"></i>
              </div>
              <div>
                <p className="fw-semibold mb-0">Guided Assessment</p>
                <p className="text-muted small mb-0">Step-by-step MCQ format</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="card rounded-4 border-0 h-100" style={{ background: '#eff6ff' }}>
            <div className="card-body d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white flex-shrink-0"
                style={{ width: 44, height: 44 }}>
                <i className="bi bi-lightning-fill"></i>
              </div>
              <div>
                <p className="fw-semibold mb-0">Instant Analysis</p>
                <p className="text-muted small mb-0">AI-powered clinical reasoning</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="card rounded-4 border-0 h-100" style={{ background: '#f0fdf4' }}>
            <div className="card-body d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-center rounded-circle bg-success text-white flex-shrink-0"
                style={{ width: 44, height: 44 }}>
                <i className="bi bi-shield-lock-fill"></i>
              </div>
              <div>
                <p className="fw-semibold mb-0">Private &amp; Secure</p>
                <p className="text-muted small mb-0">Your data stays confidential</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
